import { render, staticRenderFns } from "./TransferToOtherBanksModal2.vue?vue&type=template&id=37636676&scoped=true&"
import script from "./TransferToOtherBanksModal2.vue?vue&type=script&lang=js&"
export * from "./TransferToOtherBanksModal2.vue?vue&type=script&lang=js&"
import style0 from "./TransferToOtherBanksModal2.vue?vue&type=style&index=0&id=37636676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37636676",
  null
  
)

export default component.exports